module.exports = __webpack_public_path__ + "img/av090.02a5fdbe.png";